export const FUZERX_FONTS = {
  BODY: {
    REGULAR: 'Inter-Regular',
    REGULAR_ITALIC: 'Inter-Italic',
    SEMIBOLD: 'Inter-SemiBold',
    SEMIBOLD_ITALIC: 'Inter-SemiBoldItalic',
    BOLD: 'Inter-Bold',
    BOLD_ITALIC: 'Inter-BoldItalic',
  } as const,
  HEADER: {
    REGULAR: 'Inter-Regular',
    SEMIBOLD: 'Inter-Semibold',
  } as const,
} as const;

export type FontTokens = typeof FUZERX_FONTS;
// Post-rebrand there is a single brand. The setter remains so startup code (ThemeProvider /
// applyDesignBrand) still assigns it and a future brand can be reintroduced without re-plumbing consumers.
let FONT: FontTokens = FUZERX_FONTS;

export const setFonts = (font: FontTokens) => {
  FONT = font;
};

export { FONT };
